import {setRoutes} from "../services/router/router.service"
export const mutations = {
  addMenu(state, menu) {
    state.menu = menu
    setRoutes();
  },
  showWarningModal(state, value) {
    state.showWarningModal = value;
  },
  updateAuthentication(state, input) {
    state.authenticated = input;
  },
  updateUserManagement(state, input) {
    state.userManagement = input;
  },
  updatePermissions(state, input) {
    state.permissions = input;
    state.AppActiveUser = {};
    localStorage.setItem("userInfo", JSON.stringify({}));
    state.NavMenuItems = [];
  },
  updateSecret(state, input) {
    state.secret = input;
  },
}
